export default "__VITE_ASSET__adddb092__"